import {css} from '@logistics-frontend/blocks/theme/css'
import {spacing} from '@logistics-frontend/blocks/theme/theme'

export const drawer = css`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`
export const notifications = css`
  inset-block-end: ${spacing(2)};
`
